import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';


// Guard provides a way to intercept routing between pages - in this case, ap-routing.module.ts has this example:
/*
  {
    path: 'home',
    loadChildren: () => 
      import('./pages/home/home.module').then( m => m.HomePageModule),
      canActivate: [AuthGuard]
  }
*/
//  Basically says that when navigating to home, use the home module, but check using 
//  'canActivate' by using class AuthGuard

// The AuthGuard class below simply checks that the user is logged in, 
//    - if they are, return true.
//    - if they aren't, navigate to the login page

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    //console.log("x-client-authguard-canActivate");
    // check if user has a valid session and token in authService
    return new Promise(async (resolve) => {

      let res = await this.authService.checkLogin();
      if (res)
      {
        console.log('x-client-guard-authguard-true');
        resolve(true);
        return;
      }
      if (this.authService.APP_TYPE == 'mobile' && this.authService.gotUser == true) 
      {
        console.log("Guard ok: Mobile app, and we have user!");
        resolve(true); 
        return;
      }
      // if login validation was unsuccess logout user and redirect to login page
      this.authService.logout(); 
      this.router.navigateByUrl("/login");
      resolve(false);
    })
  }
  
}
